var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBorderCornerSmallDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 63,
  fill: "none",
  viewBox: "0 0 35 63"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 4.18,
  d: "M0 60h32V0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 32.539,
  x2: 0,
  y1: 30.535,
  y2: 30.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBorderCornerSmallDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSI2MyIgdmlld0JveD0iMCAwIDM1IDYzIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMCA2MEgzMlYwIiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8zXzY5NSkiIHN0cm9rZS13aWR0aD0iNC4xOCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfM182OTUiIHgxPSIzMi41Mzg5IiB5MT0iMzAuNTM1IiB4Mj0iMCIgeTI9IjMwLjUzNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMjZGMDI4Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAxMUYyMSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==";